import { useState } from 'react';

import { ACTIVITY_LEVELS } from '../../../../shared/domain/nutrition/energy.js';
import { profileFieldsSchema } from '../../../../shared/schema/profile.schema.js';
import { Field } from '../../../ui/Field.jsx';

const INITIAL = { sex: '', age: '', feet: '', inches: '', weightLb: '', goalWeightLb: '',
  goal: 'maintain', rateLbPerWeek: '0', proteinPerLb: '1', activity: 'moderate', dailyGoal: 0, zip: '' };

export function OnboardingWizard({ onSave }) {
  const [step, setStep] = useState(1);
  const [draft, setDraft] = useState(INITIAL);
  const [error, setError] = useState(null);
  const [pending, setPending] = useState(false);
  const update = (key) => (event) => setDraft((current) => ({ ...current, [key]: event.target.value }));

  async function submit(event) {
    event.preventDefault();
    const candidate = { sex: draft.sex, age: Number(draft.age),
      heightIn: Number(draft.feet) * 12 + Number(draft.inches), weightLb: Number(draft.weightLb),
      goalWeightLb: draft.goalWeightLb ? Number(draft.goalWeightLb) : null, goal: draft.goal,
      rateLbPerWeek: Number(draft.rateLbPerWeek), proteinPerLb: Number(draft.proteinPerLb),
      activity: draft.activity, dailyGoal: 0, zip: draft.zip };
    const parsed = profileFieldsSchema.safeParse(candidate);
    if (!parsed.success) { setError(parsed.error.issues[0].message); return; }
    setPending(true); setError(null);
    try { await onSave(parsed.data); }
    catch (caught) { setError(caught.message ?? 'Your profile did not save.'); }
    finally { setPending(false); }
  }

  return (
    <main className="auth-screen">
      <form className="card auth-screen__card" onSubmit={submit}>
        <p className="lab">Setup {step} of 2</p>
        <h1 className="auth-form__title">{step === 1 ? 'About you' : 'Your goals'}</h1>
        <p className="auth-form__subtitle">This drives your calorie and macro targets.</p>
        {error ? <p className="auth-form__failure" role="alert">{error}</p> : null}
        {step === 1 ? <>
          <Field label="Sex" required>{({ id }) => <select id={id} className="input" value={draft.sex} onChange={update('sex')}><option value="">Select</option><option value="male">Male</option><option value="female">Female</option></select>}</Field>
          <Field label="Age" required>{({ id }) => <input id={id} className="input num" type="number" value={draft.age} onChange={update('age')} />}</Field>
          <div className="onboarding-grid"><Field label="Height, feet" required>{({ id }) => <input id={id} className="input num" type="number" value={draft.feet} onChange={update('feet')} />}</Field><Field label="Height, inches" required>{({ id }) => <input id={id} className="input num" type="number" value={draft.inches} onChange={update('inches')} />}</Field></div>
          <Field label="Current weight, lb" required>{({ id }) => <input id={id} className="input num" type="number" value={draft.weightLb} onChange={update('weightLb')} />}</Field>
          <button type="button" className="btn btn--accent auth-form__submit" onClick={() => setStep(2)}>Continue</button>
        </> : <>
          <Field label="Goal" required>{({ id }) => <select id={id} className="input" value={draft.goal} onChange={update('goal')}><option value="cut">Lose weight</option><option value="maintain">Maintain</option><option value="gain">Gain weight</option></select>}</Field>
          <Field label="Goal weight, lb">{({ id }) => <input id={id} className="input num" type="number" value={draft.goalWeightLb} onChange={update('goalWeightLb')} />}</Field>
          <Field label="Lifestyle activity" required>{({ id }) => <select id={id} className="input" value={draft.activity} onChange={update('activity')}>{ACTIVITY_LEVELS.map((item) => <option key={item.key} value={item.key}>{item.label}</option>)}</select>}</Field>
          <Field label="ZIP code">{({ id }) => <input id={id} className="input num" inputMode="numeric" value={draft.zip} onChange={update('zip')} />}</Field>
          <div className="onboarding-actions"><button type="button" className="btn" onClick={() => setStep(1)}>Back</button><button type="submit" className="btn btn--accent" disabled={pending}>{pending ? 'Saving...' : 'Finish setup'}</button></div>
        </>}
      </form>
    </main>
  );
}
